import React, { useState, useEffect } from 'react'
import { Modal, Form, InputNumber, App } from 'antd'
import { useDingdanshouruCWCHMutation } from '../../store/DianShangYeWuApi'
import Icon from '../../cpn/Icon'
import dayjs from 'dayjs'
function IncomeFinanceAmount(props) {
  const { message } = App.useApp()
  const [open, setOpen] = useState(false)
  const [info, setInfo] = useState({
    ddsr_id:props.ddsr_id,
    ddsr_state: props.ddsr_state,
    ddsr_cw_content:'',
    ddsr_amount:props.ddsr_amount,
  })
  const [form] = Form.useForm()
  const [updateSave] = useDingdanshouruCWCHMutation()
  useEffect(() => {
    form.setFieldsValue({
        ddsr_id:props.ddsr_id,
        ddsr_state: props.ddsr_state,
        ddsr_cw_content:'',
        ddsr_amount:props.ddsr_amount,
    })
  }, [props.ddsr_id, props.ddsr_state, props.ddsr_amount, form])
  return (
    <>
        <Icon type='financeAmount' onClick={() => setOpen(true)} />
        <Modal
            title='财务改金额'
            open={open}
            onCancel={() => setOpen(false)}
            onOk={() => {
                updateSave({
                    ddsr_id:props.ddsr_id,
                    ddsr_state: props.ddsr_state,
                    ddsr_cw_content:props.ddsr_cw_content+`！${dayjs().format('YYYY-MM-DD HH:mm:ss')} 财务操作：财务改金额，原始价格为${props.ddsr_amount}`,
                    ddsr_amount:info.ddsr_amount,
                }).then((res) => {
                    if(res.data.Status === 'success') {
                        message.success('财务改金额成功！')
                        setOpen(false)
                    } else {
                        message.error('财务改金额失败！'+res.data.Message)
                    }
                }).catch((err) => {
                    message.error('财务改金额失败！'+err.message)
                })
            }}
        >
            <Form form={form} labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
                <Form.Item label='金额' name='ddsr_amount' rules={[{ required: true, message: '请输入金额' }]}>
                    <InputNumber 
                        min={0.01} 
                        max={99999999.99} 
                        step={0.01} 
                        onChange={(value) => {
                            setInfo(prev => ({ ...prev, ddsr_amount: value }))
                        }}
                        style={{ width: '100%' }}
                    />
                </Form.Item>
            </Form>
        </Modal>
    </>
  )
}

export default IncomeFinanceAmount